<template>
  <nx-bform class="login-form" @submit="login">
    <h3 :style="isDayTime() ? '':'color: white'">{{ $t("title") }}</h3>

    <nx-bform-server-errors />

    <div class="login-box">
      <LoginNameFormGroup v-model="identity.username" required />

      <LoginPasswordNewFormGroup v-model="identity.password" required />
      <div class="d-flex">
        <b-button class="login-button" type="submit">{{
          $t("login")
        }}</b-button>

        <IAMSmartLoginPlainButton
          class="ml-2"
          data-method="iam-smart"
          @click="login"
        />

        <div
          @click="onClickIamSmartLink()"
          class="d-flex align-items-end moreinfo"
          style="padding-left: 10px; padding-right: 10px; text-decoration: underline; cursor: pointer;"
          tabindex="0"
          >{{ $t("iamSmartMoreInfo") }}
        </div>
      </div>

      <div class="login-form__query">
        
      </div>

      <div class="login-form__query">
        <router-link :to="{ name: 'LoginForgetPassword' }">
          {{ $t("query.forgetPassword") }}
        </router-link>

        <router-link :to="{ name: 'LoginForgetCertification' }">
          {{ $t("query.forgetCertification") }}
        </router-link>

        <div @click="openModal" style="cursor: pointer" tabindex="0">
          {{ $t("query.activateProfessional") }}
        </div>
        <div @click="openOwnerAssistantModal" style="cursor: pointer" tabindex="0">
          {{ $t("query.activeAssistantOwner") }}
        </div>
      </div>

      <div class="d-flex justify-content-between mt-3">
        <div class="bd-black" style="font-weight: 500;font-size: 0.95em;">{{$t('hotline')}}</div>
        <a class="login-link" href="tel:35801000">3580 1000</a> 
      </div>
      <div class="d-flex flex-column align-items-end">
        <a class="bd-black" style="font-size: 12px; color:#007bff">{{$t('hotline-msg-1')}}</a>
        <a class="bd-black" style="font-size: 12px; color:#007bff">{{$t('hotline-msg-2')}}</a>
        <a class="bd-black" style="font-size: 12px; color:#007bff">{{$t('hotline-msg-3')}}</a> 
      </div>
      <div class="d-flex justify-content-between mt-2">
        <div class="bd-black" style="font-weight: 500;font-size: 0.95em;">{{$t('email')}}</div>
        <a class="login-link" href="mailto:esh-helpdesk@bd.gov.hk">esh-helpdesk@bd.gov.hk</a>
      </div>
      <div class="mt-3" v-for="news in newsList" :key="news.id">
        <div class="bd-orange" v-dompurify-html="news.content"></div>
      </div>
      <div class="shield">
        <img src="@/assets/login/shield.png" alt="shield"/>
      </div>
    </div>

    <b-modal
      class="modelStyle"
      size="sm"
      id="registration-professional-activate-modal"
      centered
      hide-footer
    >
      <div class="d-flex registration-professional-activate">
        <div class="login">
          <div class="info-btn" style="padding-left: 8px;">
            <b-button style="width: 255px" @click="goToRegister">{{$t("activateWithECert")}}</b-button >
          </div>
          <IAMSmartLoginPlainButton
            class="ml-2 btn_text"
            data-method="iam-smart"
            @click="getQrCodeForRegister"
          />
          <div class="login-form__query">
            <b-link
              href=""
              @click="onClickIamSmartLink()"
              style="width: 100%; text-align: center; text-decoration: underline"
              >{{ $t("iamSmartMoreInfo") }}</b-link
            >
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modelStyle"
      size="sm"
      id="activate-owner-assistant-modal"
      centered
      hide-footer
    >
      <div class="d-flex registration-professional-activate">

        <div class="login">
          <div class="info-btn" style="padding-left: 8px;">
            <b-button style="width: 255px" @click="ownerAssistantEcertActivate">{{$t("activateWithECert")}}</b-button >
          </div>
          <IAMSmartLoginPlainButton class="ml-2 btn_text" @click="getQrCode" >{{ $t("activateWithIAMSmart") }}</IAMSmartLoginPlainButton>
          <div class="login-form__query">
            <b-link
              href=""
              @click="onClickIamSmartLink()"
              style="width: 100%; text-align: center; text-decoration: underline"
              >{{ $t("iamSmartMoreInfo") }}</b-link>
          </div>
          <div class="info-btn" style="padding-left: 8px;">
            <b-button style="width: 255px" @click="setupInitialPwdCode">{{$t("setupInitialPwd")}}</b-button >
          </div>
        </div>
      </div>
    </b-modal>
    <NxSigningModal
      :username="identity.username"
      :password="identity.password"
      :files="[{name: fileName,id: fileId}]"
      v-model="showSignModal"
      @signComplete="signComplete()"
    /> 

  </nx-bform>
</template>

<script>
import { UserService } from "@/services";
import { IAmSmartQrCodeApi } from "@/api";
import LoginNameFormGroup from "@/forms/login/LoginNameFormGroup";
import LoginRoleFormGroup from "@/forms/login/LoginRoleFormGroup";
import LoginPasswordNewFormDescription from "@/forms/login/LoginPasswordNewFormDescription";
import LoginPasswordNewFormGroup from "@/forms/login/LoginPasswordNewFormGroup";
import { IAMSmartLoginPlainButton,IAMSmartButton } from "@nextore/iam-smart";
import Url from "url-parse";
import NxSigningModal from '@/components/nx-signing-modal/NxSigningModal';
import { MaintainNewsApi } from '@/api';

export default {
  components: {
    NxSigningModal,
    LoginPasswordNewFormGroup,
    LoginNameFormGroup,
    LoginRoleFormGroup,
    LoginPasswordNewFormDescription,
    IAMSmartLoginPlainButton,
    IAMSmartButton
  },
  data() {
    return {
      identity: {
        username: "",
        password: "",
      },
      loginAsOptions: [],
      invitationCode: "",
      showSignModal: false,
      fileId: null,
      file: [],
      fileName: '',
      newsList: [],
      pagination: {
        page: 0,
        size: 15,
        sort: 'date desc'
      }
    };
  },
  async created() {
    var lang = this.$route.query.lang;
    if (lang) {
      this.$root.$i18n.locale = lang;
    }
    await this.updateList();
    IAMSmartLoginPlainButton.i18n.messages.en.iAMSmart.login = "Continue with iAM Smart";
    IAMSmartLoginPlainButton.i18n.messages.zh_hk.iAMSmart.login = "以智方便繼續";
    IAMSmartLoginPlainButton.i18n.messages.zh_cn.iAMSmart.login = "以智方便继续";

  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.updateList();
      }
    }
  },
  methods: {
    async login(evt) {
      const loginMethod = (evt.submitter || evt.currentTarget).dataset.method;
      let url = null;

      if (loginMethod === "iam-smart") {
        url = await this.iamSmartLogin();
        
      } else {
        url = await this.defaultLogin();
      }
      if(url){
        window.location.assign(url);
      }
    },
    //#region REVIEW default Login
    async defaultLogin() {
      const { username, password } = this.identity;
      let lang = this.$i18n.locale.replace(/_/i, '-');
      var res = await UserService.loginESH(username, password, lang);
      if(res?.response?.data.includes("ERR_AUTH_0008")){ //E-cert is not present
        this.showSignModal = true;
        return '';
      }else{
        return process.env.VUE_APP_ESS_URL;
      }
    },
    //#endregion
    async iamSmartLogin() {
      let lang;
      var result;
      switch (this.$i18n.locale) {
        case "zh_hk":
          lang = "zh-HK";
          result = await IAmSmartQrCodeApi.getQrCodeUrlHk();
          break;
        case "zh_cn":
          lang = "zh-CN";
          result = await IAmSmartQrCodeApi.getQrCodeUrlCn();
          break;
        default:
          lang = "en-US";
          result = await IAmSmartQrCodeApi.getQrCodeUrlUs();
      }

      const url = new Url(result.data.url, true);
      url.set("query", {
        ...url.query,
        lang,
      });
      return url.toString();
    },
    async getQrCode() {
      console.log("this.invitationCode", this.invitationCode);
      let lang = this.$i18n.locale;
      const res = await IAmSmartQrCodeApi.getQrCodeForInvite(lang);
      window.location.assign(res.data.url);
    },
    async getQrCodeForRegister() {
      console.log("this.registerCode");
      let lang = this.$i18n.locale;
      const res = await IAmSmartQrCodeApi.getQrCodeForRegister(lang);
      window.location.assign(res.data.url);
    },
    /*openIAmSmartApp(){
      document.location.assign(process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME + "://profile?ticketID=1234");
    },*/
    onClickIamSmartLink() {
      if (this.$i18n.locale === "zh_cn") {
        window.open("https://www.iamsmart.gov.hk/sc/");
      } else if (this.$i18n.locale === "zh_hk") {
        window.open("https://www.iamsmart.gov.hk/tc/");
      } else {
        window.open("https://www.iamsmart.gov.hk/en/");
      }
    },
    openModal() {
      this.$bvModal.show("registration-professional-activate-modal");
    },
    openOwnerAssistantModal() {
      this.$bvModal.show("activate-owner-assistant-modal");
    },
    goToRegister() {
      this.$router.push({
        name: "ERegistrationProfessionalActivate",
      });
    },
    ownerAssistantEcertActivate() {
      this.$router.push({
          name: 'LoginIAMSmartInvitationView',
          params:{
            ecert : true
          }
      });
    },
    isDayTime() {
      var nowTime = moment().hour()
      if(nowTime >= 6 && nowTime < 18) return true;
      else return false;
    },
    setupInitialPwdCode() {
      this.$router.push({
          name: 'LoginActivationKeyView'
      });
    },
    signComplete() {
      this.fetchFiles();
    },
    async updateList(pageable) {
      let params = pageable || this.pagination;
      const { data } = await MaintainNewsApi.getLatestNewstList({...params, language: this.$i18n.locale});
      const { content, pagination } = data
      this.newsList = content.filter(row => row.language === this.$i18n.locale).filter(row => row.type == 'system');
      this.pagination = pagination;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 查找具有 data-method="iam-smart" 属性的 button 元素
      const button = document.querySelector('button[data-method="iam-smart"]');
      if (button) {
        // 查找 button 内的 span 标签
        const span = button.querySelector('span');
        // 如果找到 span 标签，获取其文本内容
        if (span) {
          const spanText = span.textContent.trim(); // 去除前后空格
          // 查找 button 内的 img 标签
          const img = button.querySelector('img');
          // 如果找到 img 标签，为其添加 alt 属性，并赋值为 span 的内容
          if (img) {
            img.setAttribute('alt', spanText);
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
/* 針對 iAM Smart 按鈕的樣式 */
::v-deep button[data-method="iam-smart"] {
  /* 保持原有背景色 */
  background-color: #2b7367;
  /* 移除可能干擾焦點顯示的邊框 */
  border: none;
  /* 使用 box-shadow 代替邊框 */
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2);
  /* 確保按鈕內容正確對齊 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* 確保元素可以顯示輪廓 */
  position: relative;
  z-index: 1;
}

/* 鍵盤焦點狀態 */
::v-deep button[data-method="iam-smart"]:focus-visible {
  /* 清晰的焦點輪廓 */
  outline: 3px solid #ffffff;
  // outline-offset: 2px;
  /* 添加發光效果增強可見性 */
  // box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
}

/* 滑鼠懸停狀態 */
::v-deep button[data-method="iam-smart"]:hover {
  /* 輕微的亮度變化 */
  filter: brightness(1.1);
}

/* 按下狀態 */
::v-deep button[data-method="iam-smart"]:active {
  /* 輕微的暗度變化 */
  filter: brightness(0.9);
}

/* 確保圖標和文字正確對齊 */
::v-deep button[data-method="iam-smart"] img {
  margin-right: 8px;
  vertical-align: middle;
}

/* 確保按鈕文字可讀性 */
::v-deep button[data-method="iam-smart"] span {
  color: #ffffff;
  font-weight: 500;
}

.registration-professional-activate {
  padding: 50px 0;
  justify-content: space-around;
  .register {
    width: 200px;
    height: 150px;
    color: #fff;
    line-height: 150px;
    /*padding-top: 50px;*/
    text-align: center;
    display: table-cell;
    /*font-weight: 800;*/
    background-color: #005e97;
    border-radius: 0.25rem;
    cursor: pointer;
  }
  .login .btn_text {
    width: 255px !important;
    /*font-weight: 800 !important;*/
    /*white-space: normal !important;*/
  }
  .login .btn_text span {
    white-space: normal !important;
  }
}
.info-btn {
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #005d99;
  border: 1px;
  font-weight: 400 !important;
}
.modelStyle .bg-secondary {
  background-color: #005d99 !important;
}
</style>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>
